import { initDependencies, setupDependencies } from './app';

setupDependencies();

initDependencies();

const { runApp } = require('./services/runApp');
runApp();

/* eslint-disable */
if ((module as any).hot) {
  (module as any).hot.accept();
}
/* eslint-enable */
